
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7115/api/',
    //Live

    //DEV
   

    // Demo
    apiUrl: 'https://bps-api.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

